import {
  calculateProductPrice,
  calculateProductPriceWithFees,
} from "hooks/helpers";
import { ISurcharge, SurchargeType } from "@evennt-tech/api-v2-core";

export type CalculatePriceWithFeesArgs = {
  showDeliveryStart: Date;
  surcharges: ISurcharge[];
  productPrice?: number | null;
  showProductPrice?: number | null;
  organiserFee: number;
  showSupplierFee: number;
};

const calculatePriceWithFees = ({
  showDeliveryStart,
  surcharges,
  productPrice,
  showProductPrice,
  showSupplierFee,
  organiserFee,
}: CalculatePriceWithFeesArgs) => {
  const price = calculateProductPrice(
    showDeliveryStart,
    surcharges,
    productPrice,
    showProductPrice
  );

  return price && price !== SurchargeType.unpublish
    ? calculateProductPriceWithFees(price, organiserFee, showSupplierFee)
    : 0;
};

export default calculatePriceWithFees;
